import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MobileFilterMenu from '../Components/MobileFilterMenu';
import { translate } from '../Services/translation';
import { Faders } from 'phosphor-react';

const FilterTogglerButton = () => {
  const facetedSearchState = useSelector((state) => state.facetedSearch);
  const activeFiltersCount = facetedSearchState.facetFilters
    .map((f) => f.selectedOptions.length)
    .reduce((a, b) => a + b, 0);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => setFilterMenuOpen(!filterMenuOpen)}
        className="mobile-filter-header__filter"
      >
        <Faders size={16} />
        {translate('category-page.filter')}{' '}
        {activeFiltersCount.length > 0 && { activeFiltersCount }}
      </div>
      <MobileFilterMenu
        isOpen={filterMenuOpen}
        onClosed={() => setFilterMenuOpen(false)}
      />
    </>
  );
};

export default FilterTogglerButton;
